import React from "react";
import Layout from "./Layout";
import { Shop } from "components/common/Card";
import helper from "utils/helper";
import Pagination from "components/common/Pagination";
import { SearchX } from "lucide-react";
import { useT } from "providers/I18nProvider";

const ShopSection: React.FC<{
  pagination: any;
  title: string;
  description: string;
  onShopClick?: (item: any) => void;
  /** Từ khoá đang tìm (trang /search) — để hiện "N kết quả cho ..." + trạng thái rỗng */
  searchTerm?: string;
}> = ({ pagination, title, description, onShopClick, searchTerm }) => {
  const t = useT();
  const total = Number(pagination?.total) || 0;
  const loading = !!pagination?.isLoading;
  const empty = !loading && !pagination?.items?.length;
  const resultText = searchTerm
    ? t("search.resultsFor", { count: total, term: searchTerm })
    : t("search.results", { count: total });
  return (
    <Layout
      iconName="sun-fog"
      title={title}
      description={loading ? description : resultText}
    >
      {/* Mobile: Layout ẩn description → tự hiện dòng số kết quả ở đây */}
      {!loading ? (
        <p className="md:hidden !mb-3 px-4 text-[13px] text-gray-500">{resultText}</p>
      ) : null}
      {empty ? (
        <div className="mx-4 md:mx-6 flex flex-col items-center rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 px-5 py-8 text-center">
          <SearchX className="mb-2 h-9 w-9 text-gray-300" />
          <p className="!mb-1 text-[15px] font-bold text-black01">
            {searchTerm ? t("search.emptyFor", { term: searchTerm }) : t("search.empty")}
          </p>
          <p className="!mb-0 text-[13px] text-gray-500">{t("search.emptyHint")}</p>
        </div>
      ) : null}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 px-4 md:px-6 justify-items-center items-stretch">
        {pagination?.items?.map((item: any, idx: number) => (
          <Shop
            key={idx}
            {...helper.formatShop(item)}
            onClick={() => onShopClick?.(item)}
          />
        ))}
      </div>
      <div className="flex justify-center mt-3">
        <Pagination pagination={pagination} />
      </div>
    </Layout>
  );
};

export default ShopSection;
